<template>
  <ExternalLink
    :url="post.postLink"
    :blank="true"
  >
    <div class="h-36 lg:h-60 overflow-hidden rounded-md">
      <ImgView
        :key="blogPostKey"
        :src="post.thumbnail"
        :alt="post.title"
        class="object-cover"
      />
    </div>
    <h3
      class="text-base text-EXPONDO-black pr-14 mt-3 sm:pr-0 lg:mt-5"
      v-html="post.title"
    />
    <DisplayHtmlDangerously
      class="blog-card__excerpt my-3 text-xs lg:text-sm"
      :html-text="post.excerpt"
    />
    <p class="text-xs">
      {{ creationDate }}
      {{ $t('blog-article-writer') }}
      <strong>{{ post.author }}</strong>
    </p>
    <span class="mt-4 text-EXPONDO-secondary underline text-sm font-semibold flex items-center gap-2">
      <span>{{ $t('Read more') }}</span>
      <span class="iconify svg--chevron-right mt-0.5 text-base" />
    </span>
  </ExternalLink>
</template>
<script lang="ts">

import { dateToDDMMYYYY } from '~~/helpers/time/dateToDDMMYYYY/dateToDDMMYYYY';
import type { BlogCardItem } from '~~/types/blog/BlogCardItem';

export default defineComponent({
  name: 'BlogCard',

  props: {
    post: {
      type: Object as PropType<BlogCardItem>,
      required: true,
    },
  },
  setup (props) {

    const creationDate = computed(() => dateToDDMMYYYY(props.post.createdAt));
    const blogPostKey = ref('');
    watch(() => props.post, (value) => {

      blogPostKey.value = value.title;
    
    });

    return {
      dateToDDMMYYYY,
      creationDate,
      blogPostKey,
    };
  
  },
});

</script>
<style lang="scss" scoped>
  :deep(.blog-card__excerpt) {
    p {
      @apply text-xs lg:text-sm;
    }
  }
</style>
